import { render, staticRenderFns } from "./taille-format-image-instagram.vue?vue&type=template&id=5cb03a7b&"
import script from "./taille-format-image-instagram.vue?vue&type=script&lang=js&"
export * from "./taille-format-image-instagram.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports